import { toaster } from 'uikit/Toaster'
import { api } from 'api'
import { useMutation } from '@tanstack/react-query'

export const useUpdateBannerItem = () => {
  

  return useMutation({
    mutationFn: (data: any) => api.banner.updateItem(data),
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Баннер успешно обновлен',
        type: 'success',
      })
    },
    onError: (err) => {
      toaster.create({
        title: 'Не удалось обновить данные',
        description:  err.message,
        type: 'error',
      })
    },
  })
}
